export default {
  INSERT_INTO_ALL: "INSERT_INTO_ALL_MARKETING_APARTMENT_ADS",
  ADD_TO_IN_PROGRESS: "ADD_TO_IN_PROGRESS_MARKETING_APARTMENT_ADS",
  REMOVE_FROM_IN_PROGRESS: "REMOVE_FROM_IN_PROGRESS_MARKETING_APARTMENT_ADS",
  INSERT_INTO_FORMS: "INSERT_INTO_FORMS_MARKETING_APARTMENT_ADS",
  DESTROY_FORM: "DESTROY_FORM_MARKETING_APARTMENT_ADS",
  SET_FORM_ERROR: "SET_FORM_ERROR_MARKETING_APARTMENT_ADS",
  UPDATE_FORM_INSTANCE: "UPDATE_FORM_INSTANCE_MARKETING_APARTMENT_ADS",
  INSERT_INTO_PAGINATION: "INSERT_INTO_PAGINATION_MARKETING_APARTMENT_ADS",
  INSERT_INTO_FILTERED: "INSERT_INTO_FILTERED_MARKETING_APARTMENT_ADS",
  RESET_STATE: "RESET_STATE_MARKETING_APARTMENT_ADS",
  SET_ASK_DELETE_DATA: "SET_ASK_DELETE_DATA_MARKETING_APARTMENT_ADS",
  REMOVE_OBJECT: "REMOVE_OBJECT_MARKETING_APARTMENT_ADS",
  CLEAR_FETCHED: "CLEAR_FETCHED_MARKETING_APARTMENT_ADS",
  CLEAR_NEW_PRODUCTION_FLOW_DATA: "CLEAR_NEW_PRODUCTION_FLOW_DATA",

  ADD_MULTIPLE_APARTMENTS: "ADD_MULTIPLE_APARTMENTS_APARTMENT_ADS",
  ADD_APARTMENT: "ADD_APARTMENT_APARTMENT_ADS",
  REMOVE_APARTMENT: "REMOVE_APARTMENT_APARTMENT_ADS",
  SET_ADS: "SET_ADS_APARTMENT_ADS",
  SET_DEFAULT_SETTINGS: "SET_DEFAULT_SETTINGS_APARTMENT_ADS",

  LIST_URL: "/market/ads/apartmentad/list/",
  POST_URL: "/market/ads/apartmentad/",
  PATCH_URL: "/market/ads/apartmentad/",
  GET_URL: "/market/ads/apartmentad/",

  PUBLISH_NEW_PRODUCTION_URL: "/market/homeq/publish_homeq_project/",

  STORE_NAME: "marketApartmentAds",
};
